import { createStore } from 'vuex';

const store = createStore({
    state: {
        pageTitle: '首页',  // 默认标题
    },
    mutations: {
        setPageTitle(state, title) {
            state.pageTitle = title;
        },
    },
    actions: {
        updatePageTitle({ commit }, title) {
            commit('setPageTitle', title);
        },
    },
});

export default store;



